export const mergePlayerGamesAndTests = (playerGames, playerTests, playerGameCount) => {
    let returnArr = [];
    let nbrStarted = 0;
    let nbrNotStarted = 0;
    for (let i=0; i<playerGames.length; i++){
        const player = playerGames[i].user;
        let playerStatus = "";
        if (playerGames[i].configAvail ===  true){
            playerStatus = "Game Started";
            nbrStarted += 1;
        }else{
            playerStatus = "No Active Game";
            nbrNotStarted += 1;
        }
            
        let preTestScore = "none";
        let postTestScore = "none";
        const testsTakenArr = playerTests.filter(elem => elem.user === player);
        for (let j=0; j<testsTakenArr.length; j++){
            const testScore = (+testsTakenArr[j].nbrCorrect / +testsTakenArr[j].nbrQuestions).toFixed(2);
            if (testsTakenArr[j].testType === "pre-test"){
                preTestScore = testScore.toString() + "%";
            }
            if (testsTakenArr[j].testType === "post-test"){
                postTestScore = testScore.toString() + "%";
            }
        }
        const playerGameCountObj = playerGameCount.find(elem => elem.user === player);
        let nbrGames = 0;
        let nbrGameMonths = 0;
        if (playerGameCountObj){
            nbrGames = playerGameCountObj.nbrGames;
            nbrGameMonths = playerGameCountObj.totalNbrGameMonths;
        }
        //  convert user name to lower case before sort (to fix sort order)
        const user = (playerGames[i].user).toLowerCase();
        const playerGameObj = {index: i+1, player: player,  user: user, playerStatus: playerStatus,
            preTestScore: preTestScore, postTestScore: postTestScore, nbrGames: nbrGames, 
            nbrGameMonths: nbrGameMonths }
        returnArr.push(playerGameObj);
    }
    playerGames.sort((a, b) => (a.user > b.user) ? 1 : -1);
    const returnObj = {nbrStarted: nbrStarted, nbrNotStarted: nbrNotStarted, returnArr: returnArr};
    return returnObj;
}

export default mergePlayerGamesAndTests;